<template>
    <el-container class="mainBody clfBody">
        <el-main>
            <div >
                <span>
                    <el-col :span="6" class="jjjgDiv" >
                        <el-image
                                :src="require('../img2/clf/jjjg.png')"
                                ></el-image>
                        <div class="jjjgDiv2">
                            <span>经纪机构</span>
                            <span>{{ amountData.jjjg }}家</span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="jjjgDiv">
                        <el-image
                                :src="require('../img2/clf/jjry.png')"
                                ></el-image>
                        <div class="jjjgDiv2">
                            <span>经纪人员</span>
                            <span>{{ amountData.jjry }}人</span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="jjjgDiv">
                        <el-image
                                :src="require('../img2/clf/head3.png')"
                                ></el-image>
                        <div class="jjjgDiv2">
                            <span>累计有效挂牌</span>
                            <span>{{ amountData.yxgp }}套</span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="jjjgDiv">
                        <el-image
                                :src="require('../img2/clf/ljyxcj.png')"
                                ></el-image>
                        <div class="jjjgDiv2">
                            <span>累计有效成交</span>
                            <span>{{ amountData.yxcj }}套</span>
                        </div>
                    </el-col>
                </span>
            </div>
        </el-main>
        <el-header class="headTop">
                <el-col :span="10" class="headDiv leftImg"><el-image  :src="require('../img2/clf/0031.png')" ></el-image></el-col>
                <el-col :span="4" class="headDiv"><div class="phValue">最新挂牌房源</div></el-col>
                <el-col :span="10" class="headDiv rightImg"><el-image  :src="require('../img2/clf/0031.png')" ></el-image></el-col>
        </el-header>
        <el-main>
            <el-table
                    :data="tableData"
                    style="width: 100%"
                    border
                    :header-cell-style="getRowClass"
                    :row-class-name="tableRowClassName">
                <el-table-column
                        header-align="center"
                        prop="fyhywybm"
                        label="房源核验唯一编码"
                        align="center"
                        width="200">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        prop="sscq"
                        label="所属城区"
                        align="center"
                        width="100">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        prop="xq"
                        label="小区"
                        align="center">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        prop="mj"
                        width="80"
                        align="center"
                        label="面积">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        prop="wtjg"
                        align="center"
                        label="委托价格"
                        width="80">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        prop="gpjg"
                        align="center"
                        label="挂牌机构"
                        width="260">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        prop="gpsj"
                        align="center"
                        width="120"
                        label="挂牌时间">
                </el-table-column>
                <el-table-column
                    header-align="center"
                        prop="xxxx"
                        align="center"
                        label="详细信息">
                    <template slot-scope="scope">
                        <a @click="openClfxx(scope.row.fyhywybm)">
                            查看详情
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <el-header class="headTop2">
                <el-col :span="10" class="leftImg2"><el-image  :src="require('../img2/clf/0031.png')" ></el-image></el-col>
                <el-col :span="4" class="fdcxs"><div class="phValue">房地产销售排行榜</div></el-col>
                <el-col :span="10" class="rightImg2"><el-image  :src="require('../img2/clf/0031.png')" ></el-image></el-col>
            </el-header>
            <el-row>
                <el-col class="phbDivWidth">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="小区销售" name="first" >
                            <el-table
                                    :data="tableData1"
                                    style="width: 100%" :show-header="false" :row-class-name="getRowColor">
                                <el-table-column
                                        label=""
                                        type=index
                                        width="40" align="center" class-name="phbNum">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        label=""
                                        width="290">
                                </el-table-column>
                                <el-table-column
                                        prop="address"
                                        label=""
                                        width="100" align="right" class-name="NumFloat">
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="区域销售" name="second">
                            <el-table
                                    :data="tableData2"
                                    style="width: 100%" :show-header="false" :row-class-name="getRowColor">
                                <el-table-column
                                        label=""
                                        type=index
                                        width="40" align="center" class-name="phbNum">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        label=""
                                        width="290">
                                </el-table-column>
                                <el-table-column
                                        prop="address"
                                        label=""
                                        width="100" align="right" class-name="NumFloat">
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col class="phbDivWidth phbDivWidth2">
                    <el-tabs v-model="activeName2" @tab-click="handleClick2">
                        <el-tab-pane label="机构销售" name="first">
                            <el-table
                                    :data="tableData3"
                                    style="width: 100%" :show-header="false" :row-class-name="getRowColor">
                                <el-table-column
                                        label=""
                                        type=index
                                        width="40" align="center" class-name="phbNum">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        label=""
                                        width="290">
                                </el-table-column>
                                <el-table-column
                                        prop="address"
                                        label=""
                                        width="100" align="right" class-name="NumFloat">
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="经纪人销售" name="second">
                            <el-table
                                    :data="tableData4"
                                    style="width: 100%" :show-header="false" :row-class-name="getRowColor">
                                <el-table-column
                                        label=""
                                        type=index
                                        width="40" align="center" class-name="phbNum">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        label=""
                                        width="290">
                                </el-table-column>
                                <el-table-column
                                        prop="address"
                                        label=""
                                        width="100" align="right" class-name="NumFloat">
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="昨日销售" name="third">
                            <el-table
                                    :data="tableData5"
                                    style="width: 100%" :show-header="false" :row-class-name="getRowColor">
                                <el-table-column
                                        label=""
                                        type=index
                                        width="40" align="center" class-name="phbNum">
                                </el-table-column>
                                <el-table-column
                                        prop="NAME"
                                        label=""
                                        width="290">
                                </el-table-column>
                                <el-table-column
                                        prop="ADDRESS"
                                        label=""
                                        width="100" align="right" class-name="NumFloat">
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
            </el-row>


        </el-main>
    </el-container>
</template>

<script>
    import { mapActions } from 'vuex'
	import axios from 'axios';
	import config from "@/config";
	const base_url = config.baseUrl + 'clf/';
    export default {
        name: "clf_home",
        data() {
            const item = {
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            };
            const item2 = {
                date: '1',
                name: '自助签约',
                address: '2597套'
            };
            const item4 = {
                date: '1',
                name: '自助签约',
                address: '3456套'
            };
            const item5 = {
                date: '1',
                name: '自助签约',
                address: '2345套'
            };
            const item3 = {
                fyhywybm: 'H2020123001018726',
                sscq: '东昌府区',
                xq: '金柱大学城东苑',
                mj:'85.17㎡',
                wtjg:'820.00',
                gpjg:'聊城市起点房地产信息规划有限公司',
                gpsj:'2020-12-30',
                xxxx:'查看详情'
            };
            return {
				amountData: {},
                activeName: 'first',
                activeName2: 'first',
				tableData: Array(10).fill(item3),
                tableData1: Array(10).fill(item2),
                tableData2: Array(10).fill(item2),
                tableData3: Array(10).fill(item4),
                tableData4: Array(10).fill(item4),
                tableData5: Array(10).fill(item4),
                url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                imgArray: [//图片路径
                    require('../img2/clf/head3.png'),
                    require('../img2/clf/head3.png'),
                    require('../img2/clf/head3.png'),
                    require('../img2/clf/head3.png'),
                ],
            }
        },
        methods: {
            ...mapActions([
                'handleLogin',
                'getUserInfo'
            ]),
            tableRowClassName({row, rowIndex}) {
                if ( rowIndex%2 ==0) {
                    return '';
                } else if (rowIndex%2 !=0) {
                    return 'success-row';
                }
                return '';
            },
			 getRowClass ({ rowIndex }) {
				if (rowIndex == 0) {
					return 'background:#F8F8F8'
				} else {
					return ''
				}
			 },
			getRowColor({rowIndex}) {
				if ( rowIndex<3) {
					return 'phbdivcolor';
				}
				return '';
			},
            handleClick(tab, event) {
                console.log(tab, event);
            },
            handleClick2(tab, event) {
                console.log(tab, event);
            },
            indexMethod(index) {
                return index + 1;
            },
            openClfxx(fyhybm){
                this.$router.push({path:'/ywhome/clfhome/openClfxx',query:{fyhybm:fyhybm}})
            },
        },
        mounted(){
			// 统计数据
			axios.get(base_url + "tjsj").then(response => this.amountData = response.data).catch(error => console.log(error, "error"));
			// 最新挂牌房源
			axios.get(base_url + "zxgpfy").then(response => this.tableData = response.data).catch(error => console.log(error, "error"));
			// 小区销售
			axios.get(base_url + "xqxs").then(response => this.tableData1 = response.data).catch(error => console.log(error, "error"));
			// 区域销售
			axios.get(base_url + "qyxs").then(response => this.tableData2 = response.data).catch(error => console.log(error, "error"));
			// 机构销售
			axios.get(base_url + "jgxs").then(response => this.tableData3 = response.data).catch(error => console.log(error, "error"));
			// 经纪人销售
			axios.get(base_url + "jjrxs").then(response => this.tableData4 = response.data).catch(error => console.log(error, "error"));
			// 昨日销售
			axios.get(base_url + "zrxs").then(response => this.tableData5 = response.data).catch(error => console.log(error, "error"));
        },
    }
</script>

<style>
    .phValue {
        font-size: larger;
        color: #00448C;
        margin-top: -20px;
        font-weight:bolder;
    }
    .el-tabs__nav-wrap::after {
        position: static !important;
    }
    .el-image__inner--center{
        transform:none;
        top: 0;
        left: 0;
    }
    .clfBody .headDiv{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .el-tabs__item{
        color: #666666;
        font-weight: bold;
    }
    .el-tabs__item.is-active {
        color: #00448C;
    }
    .el-tabs__item:hover {
        color: #00448C;
        cursor: pointer;
    }
    .el-tabs__active-bar{
        background-color: #00448C;
    }
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #F2FAFF;
    }
    .phbNum div div{
        background-color: #DFE3E5;
        color: white;
        width: 24px;
        height: 24px;
    }
    .phbdivcolor .phbNum div div{
        background-color: #00448C;
    }
    .phbNum  div{
        padding-left: 0;
        padding-right: 0;
    }
    .phValue{
        text-align: center;
    }
    .el-table__header{
        background-color: #F8F8F8;
    }
    /*移动端样式*/
    @media screen and (max-width: 414px) {
        .jjjgDiv2{
            width:90%;
        }
        .el-tabs__item{
            font-size: 13px;
        }
        .NumFloat{
            text-align: left !important;
        }
        .el-main {
           font-size: 13px !important;
        }
        .el-table .cell{
            font-size: 13px !important;
        }
        .clfBody .leftImg{
            margin-right: 40px;
        }
        .clfBody .rightImg{
            margin-left: 40px;
        }
        .clfBody .fdcxs{
            width: 40%;
        }
        .clfBody .leftImg2{
            margin-right: 20px;
        }
        .clfBody .rightImg2{
            width: 40%;
            margin-left: 20px;
        }

        .jjjgDiv img{
            width: 70%;
            height: auto;
        }
        .phValue{
            font-size: 13px;
            white-space: nowrap;
        }
        .clfBody .headTop{
            margin-top: 10px;
            display: flex;
            height: 30px !important;
            align-items: center;
            align-content: center;
        }
        .clfBody .headTop2{
            margin-top: 30px;
            height: 20px !important;
            display: flex;
            align-items: center;
            align-content: center;

        }
        .phbDivWidth2{
            margin-top: 10px;
        }
        .el-table td, .el-table th{
            padding: 9px 0;
        }
    }
    /*PC端样式*/
    @media screen and (min-width: 414px) {
        .clfBody .el-tabs__item{
            font-size: 19px;
        }
        .mainBody{
            width: 80%;
            margin: auto;
        }
        .jjjgDiv{
            display: flex;
            align-items: center;
        }
        .jjjgDiv2{
            display: flex;
            flex-flow: column;
            margin-left:10px;
        }
        .phbDivWidth{
            width: 50%;
        }
        .headTop{
            margin-top: 20px;
            display: flex;
            align-items: center;
            align-content: center;

        }
        .headTop2{
            margin-top: 50px;
            display: flex;
            align-items: center;
            align-content: center;

        }
        .clfBody .el-table__header,.el-table__body{
            width: 100% !important;
        }
        .clfBody .rightImg2 .el-image{
            width: 100% !important;
        }
        .clfBody .leftImg2 .el-image{
            width: 100% !important;
        }
        .clfBody .rightImg .el-image{
            width: 100% !important;
        }
        .clfBody .leftImg .el-image{
            width: 100% !important;
        }
    }
</style>
